
import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';


export default function AppLayout() {
  return (
    <div className="d-flex flex-column vh-100">
      {/* Top Navbar */}
      <div className="flex-shrink-0">
        <Navbar />
      </div>

      {/* Remaining content */}
      <div className="flex-grow-1 bg-light">
        <Outlet />
      </div>
    </div>
  );
}
